const TENANT_ID_NAME = 'tenantId';
const USER_ID_NAME = 'userId';
const DEFAULT_TENANT_ID = '1e43a152-f84f-4022-a2c6-0c66c86e9e70';
const DEFAULT_USER_ID = 'ecommerce';

export const getTenantId = () => DEFAULT_TENANT_ID;

export const getUserId = () => DEFAULT_USER_ID;

function getCookie(cname) {
  const name = `${cname}=`;
  const ca = document.cookie.split(';');
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}



// WEBPACK FOOTER //
// ./src/helpers/tenant.js